export const isRedirectableURL = (url: string): boolean => {
  try {
    const urlObj = new URL(decodeURIComponent(url));
    const domain = process.env.NEXT_PUBLIC_REDICECTABLE_DOMAIN;
    if (!domain || domain === '') {
      return false;
    }
    // 同ドメインかサブドメイン
    return urlObj.hostname === domain || urlObj.hostname.endsWith(`.${domain}`);
  } catch (error) {
    return false;
  }
};
